import React from 'react'
import ImagesUroliftGallery from "./ImagesUroliftGallery"
import {Link} from "@material-ui/core"

const Schokwave_RU = () => {
    return (
        <section id="about1">
            <div className="row">
                <h2>Что такое система система UroLift?</h2>
                <p className="white">
                    Лечение с помощью системы UroLift обычно является одноразовым решением, которое обеспечивает быстрое
                    облегчение симптомов аденомы предстательной железы и выздоровление. Это может прервать цикл приема
                    лекарств без риска более инвазивной хирургии. Целью лечения с помощью системы UroLift является
                    облегчение симптомов аденомы предстательной железы, чтобы пациент мог вернуться к нормальной
                    деятельности в повседневной жизни.
                    <br/>
                    Доказано, что лечение системой UroLift приводит к значительному улучшению качества жизни по
                    сравнению с лекарственной терапией. Система UroLift - единственная процедура, которая, как было
                    доказано, не вызывает новой и постоянной эректильной дисфункции или нарушений эякуляции*, а также
                    является безопасным и эффективным средством лечения симптомов нижних мочевыводящих путей, связанных
                    с аденомой предстательной железы.
                    <br/>
                    <h2>Как работает система UroLift?</h2>
                    В лечении аденомы предстательной железы с помощью системы UroLift используется новаторский подход,
                    при котором увеличенная ткань предстательной железы поднимается и удерживается в стороне, чтобы она
                    больше не блокировала уретру. Лечение проводится урологом и не требует нагревания, разрезания или
                    удаления ткани предстательной железы. Лечение UroLift System обычно проводится с использованием
                    только местной анестезии в кабинете врача или в центре амбулаторной хирургии. Пациенты испытывают
                    быстрое облегчение симптомов, значительное улучшение качества жизни и сохранение сексуальной
                    функции. Целью лечения системой UroLift является облегчение симптомов, чтобы вы могли вернуться к
                    своей жизни и возобновить повседневную деятельность.
                    <br/>
                    <ImagesUroliftGallery/>
                    <i>Не были выявлены новые случаи эректильной дисфункции или нарушений эякуляции</i>
                    <br/>
                    Источник: <Link href="https://de.urolift.com/what-is-urolift" target="_blank">https://de.urolift.com/what-is-urolift</Link>
                </p>
            </div>
        </section>
    )
}

export default Schokwave_RU



// WEBPACK FOOTER //
// ./src/Components/Schokwave/Schokwave_RU.js